import React, { useEffect, FC, PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { configActions } from '../../../../ducks/actions'
import { useAppDispatch } from '../../../../ducks/hooks'
import {
  getError,
} from '../../../../ducks/selectors'
import ErrorPage from '../../Pages/ErrorPage'
import InitializeGoogleAnalytics from 'helpers/google-analytics'

const MainWrapper: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch()
  const error = useSelector(getError())

  useEffect(() => {
    if (!navigator.onLine) {
      dispatch(configActions.setError({ show: true, type: 'no_internet' }))
    } else {
      dispatch(configActions.setError({ show: false, type: '' }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    InitializeGoogleAnalytics()
  }, [])

  window.addEventListener('online', () => {
    dispatch(configActions.setError({ show: false, type: '' }))
  })

  window.addEventListener('offline', () => {
    dispatch(configActions.setError({ show: true, type: 'no_internet' }))
  })

  return <main>{error.show ? <ErrorPage type={error.type} /> : children}</main>
}

export default MainWrapper
